var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRotateAnticlockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.517 14.464a6.27 6.27 0 004.465 1.847 6.272 6.272 0 004.465-1.847 6.321 6.321 0 000-8.93 6.272 6.272 0 00-4.465-1.847c-1.596 0-3.1.585-4.265 1.655L7.73 7.356.013 8.503 1.16.787l1.946 1.946A9.933 9.933 0 019.982 0a9.937 9.937 0 017.074 2.926c3.9 3.9 3.9 10.246 0 14.148a9.942 9.942 0 01-7.074 2.925 9.939 9.939 0 01-7.074-2.926l-.195-.196 2.609-2.609.195.196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.082 12.262a2.165 2.165 0 110-4.33 2.165 2.165 0 010 4.33z"
  })));
}

export default SvgRotateAnticlockwise;